import english from "./home-copy.en.json";
import catalan from "./home-copy.ca.json";

export type HomeLanguage = "fr" | "en" | "ca";
const translations: Record<"en" | "ca", Record<string, string>> = { en: english, ca: catalan };

export function getHomeCopy(language: HomeLanguage) {
  return (text: string) => language === "fr" ? text : translations[language][text] ?? text;
}
